import { ApiRequest, ApiResponse, HttpMethod } from '@axl/accel-framework/api';
import { StudentCourseItem } from 'models';

export class FetchStudentCourseItemRequest extends ApiRequest {
    public method = HttpMethod.GET;
    private filesSelector = `
        id,
        name,
        cloudKey,
        extension,
        size,
        type
    `;

    private fieldsSelector = `
        id,
        title,
        placeholder,
        description,
        required,
        position,
        type,
        additionalData
    `;
    private userSelector = `
        id,
        firstName,
        lastName,
        email,
        avatar {
            id,
            name,
            cloudKey,
            extension,
            size,
            type
        }
    `;
    public fields = `{
        id,
        title,
        type,
        designHTMLPublished,
        designStylePublished,
        preventCopingAndSelectingText,
        theoryVisible,
        testsVisible,
        tasksVisible,
        ratingEnabled,
        ratingRequired,
        ratingCommentRequired,
        allowComments,
        progress{
            id,
            beginDate,
            completeDate,
            precompleteDate,
            status,
            theoryStatus,
            testStatus,
            taskStatus,
            numberUncheckedTasks,
            numberCorrectTasks,
            numberIncorrectTasks,
            rating {
                id,
                comment,
                rating,
                createdDate,
                updatedDate,
                files(filter:"{take:0}") {${this.filesSelector}}
            }
        },
        tests(filter:"{sortName:'Position', sortType: 'Asc', take:0}") {
            id,
            minPercentageCompletion,
            minScoreCompletion,
            countingMethod,
            title,
            description,
            isCompleted,
            questions(filter:"{sortName:'Position', sortType: 'Asc', take:0}") {
                id,
                question,
                score,
                multiAnswer,
                answers(filter:"{take:0}") {
                    id,
                    answer,
                    isCorrect,
                },
                position,
                file {${this.filesSelector}},
                shuffle,
            },
            position,
            shuffle,
            files(filter:"{take:0}") {${this.filesSelector}}
        },
        tasks(filter:"{sortName:'Position', sortType: 'Asc'}") {
            id,
            question,
            questionRequired,
            description,
            answer{
                id,
                status,
                createdDate,
                updatedDate,
                text,
                comments {
                    id,
                    createdDate,
                    updatedDate,
                    comment,
                    admin {
                        ${this.userSelector}
                    },
                    student {
                        ${this.userSelector}
                    },
                    files(filter:"{take:0}") {${this.filesSelector}}
                },
                files(filter:"{take:0}") {${this.filesSelector}},
                studentAnswerFields {
                    id,
                    stringValue,
                    booleanValue,
                    listValue,
                    listLabelValue,
                    multiListValue,
                    multiListLabelValue,
                    field {${this.fieldsSelector}}
                }
            },
            files(filter:"{take:0}") {${this.filesSelector}},
            fields {${this.fieldsSelector}}
        },
        files(filter:"{take:0}") {${this.filesSelector}}
    }`;
    public url: string = `/student-course-item/${this.studentCourseId}/${this.courseItemId}`;

    constructor(public studentCourseId: string, public courseItemId: string) {
        super();
    }
}

export class FetchStudentCourseItemResponse extends ApiResponse {
    public studentCourseItem: StudentCourseItem;
    constructor(response: any) {
        super(response);
        this.studentCourseItem = StudentCourseItem.fromJson(this.body);
    }
}
